/** @format */

import { useEffect, useRef, useEffectEvent } from 'react'
import { useLocation } from 'react-router-dom'
import { useSafeNavigate } from '@/shared/lib/safe-navigate'
import { useUserMe } from '@/shared/lib/hooks'
import { useAuth, useAuthStore } from '@/entities/auth/model'

export const useAuthHandler = () => {
  const navigate = useSafeNavigate()
  const { pathname } = useLocation()
  const getUserMe = useUserMe()
  const { token } = useAuth()
  const prevTokenRef = useRef(token)

  // React 19.2: useEffectEvent wraps getUserMe (mutation object, new every render)
  // so it doesn't need to be in the useEffect dependency array
  const onAuthCheck = useEffectEvent(() => {
    getUserMe?.mutate(undefined)
  })

  useEffect(() => {
    const prevToken = prevTokenRef.current
    const tokenChanged = prevToken !== token

    if (!token) {
      if (pathname !== '/login' && pathname !== '/') {
        navigate('/login', { replace: true })
      }
    } else if (tokenChanged && !prevToken) {
      // Token arrived from null (login or cross-tab login).
      // login() calls fetchMeAndHydrate() BEFORE setToken(), so by the time
      // this effect fires the user is already in the store. Only call /me
      // for cross-tab login where the receiver tab has no user data yet.
      const alreadyHydrated = !!useAuthStore.getState().user?.id
      if (!alreadyHydrated) {
        onAuthCheck()
      }
    }

    prevTokenRef.current = token
  }, [token, pathname, navigate, onAuthCheck])
}
